function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { handleError } from '../../store/features/alertSlice';
import businessUnitsService from '../../services/business_unit.service';
const BusinessUnitEditForm = _ref => {
  var _businessUnit$name;
  let {
    bussinessUnitToEdit,
    setIsEditing,
    company,
    setCompany,
    loading,
    setLoading,
    index,
    onEditComplete
  } = _ref;
  const [businessUnit, setBusinessUnit] = useState(null);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setBusinessUnit(bussinessUnitToEdit);
  }, [bussinessUnitToEdit]);
  const handleChange = e => {
    const value = e.target.value;
    setBusinessUnit(_objectSpread(_objectSpread({}, businessUnit), {}, {
      [e.target.name]: value
    }));
  };
  const handleEditBusinessUnit = async () => {
    try {
      setLoading(true);
      const editedBu = await businessUnitsService.update(company.id, businessUnit);
      const newBusinessUnits = [...(company.business_units || [])];
      newBusinessUnits[index] = editedBu;
      setCompany(_objectSpread(_objectSpread({}, company), {}, {
        business_units: newBusinessUnits
      }));
      setIsEditing(false);
      if (onEditComplete) {
        await onEditComplete();
      }
    } catch (e) {
      dispatch(handleError(e));
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('Name')), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Control, {
    name: "name",
    onChange: handleChange,
    value: businessUnit === null || businessUnit === void 0 ? void 0 : businessUnit.name,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('State')), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "state",
    onChange: handleChange,
    value: businessUnit === null || businessUnit === void 0 ? void 0 : businessUnit.state,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: "active"
  }, "Active"), /*#__PURE__*/React.createElement("option", {
    value: "not_active"
  }, "Not Active")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: (businessUnit === null || businessUnit === void 0 || (_businessUnit$name = businessUnit.name) === null || _businessUnit$name === void 0 ? void 0 : _businessUnit$name.length) < 1,
    onClick: () => handleEditBusinessUnit(),
    icon: "save",
    iconPosition: 'left',
    loading: loading,
    variant: "primary"
  }, t('edit_business_unit')))));
};
export default BusinessUnitEditForm;